import { render } from "./pdf.vue?vue&type=template&id=be8f816e&scoped=true"
import script from "./pdf.vue?vue&type=script&lang=js"
export * from "./pdf.vue?vue&type=script&lang=js"

import "./pdf.vue?vue&type=style&index=0&id=be8f816e&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be8f816e"]])

export default __exports__